<template lang="pug">
  v-menu(:close-on-content-click='false' :nudge-width='200' v-model='menu' offset-x='')
    //- v-btn(slot='activator' color='indigo' dark='') Menu as Popover
    v-btn(slot='activator' fab='' dark='' small='' color='info')
      v-icon(dark='') person
    v-card
      h3.text-md-center Sesión Actual
      v-divider
      v-list
        v-list-tile(avatar='')
          v-list-tile-avatar
            img(:src="image_logo" alt='John')
          v-list-tile-content
            v-list-tile-title {{infoSession.userName}}
            v-list-tile-sub-title ID Caja : {{infoSession.number}}
            v-list-tile-sub-title Sucursal: {{infoSession.name}} 
      slot
          //- v-list-tile-action
          //-   v-btn(:class="fav ? 'red--text' : ''" icon='' @click='fav = !fav')
          //-     v-icon favorite
      v-card-title.text-uppercase.justify-end.pt-0.pb-2
        strong {{ version }}
</template>

<script>
export default {
    name: 'sessionBox',
    props: {
        infoSession: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            fav: true,
            menu: false,
            image_logo: require('../../assets/user_male.png'),
        }
    },
    computed: {      
      
      /**
       * Get the app version
       * @type {String}
       */
      version() {
        return process.env.VUE_APP_VERSION
      },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
    },
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss"></style>
